'use strict';

import { CoreRepository } from '../CoreRepository';
import { UserLetter } from '../../Entities/User/UserLetter';
//import { UserLetterSharingCollection } from '../Collections/UserLetterSharingCollection';

export class UserLetterSharingRepository extends CoreRepository {
  /*
  public getUserLettersSharing(userId: number, type: string, options: object = {}, criteria: object = null) {
    if (!options) {
      options = {};
    }

    if (criteria) {
      options['criteria'] = criteria;
    }

    return this.webAPI.getUserLetters(userId, type, options)
      .then(response => {
        let collection = new UserLetterSharingCollection();

        response.data.forEach(collectionItemData => {
          let collectionItem = new UserLetter();
          collectionItem.hydrate(collectionItemData);

          collection.addItem(collectionItem);
        });

        collection.setOffset(response.offset);
        collection.setLimit(response.limit);
        collection.setTotal(response.total);

        return collection;
      });

  }
*/

  public createUserLetterSharing(userId: number, letterId: number, payload: object = {}) {
    return this.webAPI.createUserLetterSharing(userId, letterId, payload).then((response) => {
      return response;
    });
  }

  public deleteUserLetterSharing(userId: number, shareId: number) {
    return this.webAPI.deleteUserLetterSharing(userId, shareId).then((response) => {
      return response;
    });
  }
}
